import styled from '@emotion/styled';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const TabControlsWrapper = styled.div({
  padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-200, 16px)"}`
});